import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import { start } from './lib/installeren'
import './styles/app.css'

start()
createRoot(document.getElementById('app')!).render(<StrictMode><App /></StrictMode>)
